import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserCareerFairGame from 'src/games/CareerFairGame/Main';

interface CareerFairGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class CareerFairGame extends React.Component<CareerFairGameProps> {
    constructor(props: CareerFairGameProps) {
        super(props);
        bindAllOfThis(this, CareerFairGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserCareerFairGame onComplete={this.completeGame} />
        </div>;
    }
}

export default CareerFairGame;



// WEBPACK FOOTER //
// ./src/pages/game/CareerFairGame.tsx